import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_RENEW = "GET_LIST_RENEW";
export const GET_DETAIL_RENEW = "GET_DETAIL_RENEW";
export const SAVE_RENEW = "SAVE_RENEW";
export const UPDATE_RENEW = "UPDATE_RENEW";
export const DELETE_RENEW = "DELETE_RENEW";
export const GET_DATA_SEARCH_RENEW = "GET_DATA_SEARCH_RENEW";
export const SET_DATA_SEARCH_RENEW = "SET_DATA_SEARCH_RENEW";
export const SET_LIST_RENEW = "SET_LIST_RENEW";
export const SET_DETAIL_RENEW = "SET_DETAIL_RENEW";





const state = {
    renew_list: [],
    renew: {},
    renewSearch: [],
};

const getters = {
    renews(state) {
        return state.renew_list;
    },
    renewDetail(state) {
        return state.renew;
    },
    dataSearchRenew(state) {
        return state.renewSearch;
    },
};

const actions = {
    [GET_LIST_RENEW](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_RENEW, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_RENEW, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DATA_SEARCH_RENEW](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_RENEW_SEARCH, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DATA_SEARCH_RENEW, data.data.data);
                }
                resolve(data);
            });
        });
    },

    [GET_DETAIL_RENEW](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_RENEW}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DETAIL_RENEW, data);
                }
                resolve(data);
            });
        });
    },

    [SAVE_RENEW](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_RENEW}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_RENEW](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_RENEW}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_RENEW](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_RENEW}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_RENEW](state, data) {
        state.renew_list =  data.data
    },
    [SET_DETAIL_RENEW](state, data) {
        state.renew = data.data;
    },
    [SET_DATA_SEARCH_RENEW](state, data) {
        state.renewSearch = data
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};